export default __webpack_public_path__ + "static/media/formationtherestoringstandard.5ec8f496.png";